import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {getContestResult, getIsGameOverModalOpen, getIsGameStarted} from "modules/selectors";
import {eq, filter, get} from "lodash";
import {NUM_CHANCES} from "modules/constants";

export const GameOverHandler: React.FC = () => {
	const isOpen = useSelector(getIsGameOverModalOpen);
	const navigate = useNavigate();
	const contestResult = useSelector(getContestResult);
	const location = useLocation();
	const predictions = get(contestResult, "predictions", []);
	const inCorrectPredictions = filter(predictions, (prd) => eq(prd.isCorrect, false));
	const isGameStarted = useSelector(getIsGameStarted);

	useEffect(() => {
		if (eq(inCorrectPredictions.length, NUM_CHANCES) && !isGameStarted && !isOpen) {
			navigate("/summary" + location.search);
		}
	}, [navigate, inCorrectPredictions, isOpen, isGameStarted, location.search]);

	return null;
};
